let isOnOfflineMode = false
let hasTriedFetching = false

export const setOfflineMode = status => {
    isOnOfflineMode = status
    console.log(`App is now ${isOnOfflineMode ? 'offline' : 'online'}`)
}

export const testApiConnection = async (url, retries = 2, timeout = 5000) => {
    if (isOnOfflineMode && hasTriedFetching) {
        setOfflineMode(true) //Skipping fetch: app is offline and retries were already attempted.
        return { maintenance_mode: false, message: '' }
    }

    for (let attempt = 1; attempt <= retries; attempt++) {
        try {
            const controller = new AbortController()
            const timer = setTimeout(() => controller.abort(), timeout)

            const response = await fetch(url, { signal: controller.signal })
            clearTimeout(timer)

            if (response.ok) {
                const data = await response.json()
                setOfflineMode(false) // Reset offline mode on success
                hasTriedFetching = false // Reset retry tracking
                return data
            } else {
                console.log('Non-ok response received. Retrying...')
            }
        } catch (error) {
            console.log(`Connection failed on attempt ${attempt}. Retrying...`)
        }

        if (attempt < retries) {
            await new Promise(resolve => setTimeout(resolve, 2000))
        }
    }

    setOfflineMode(true)
    hasTriedFetching = true
    return { maintenance_mode: false, message: '' }
}
